// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verifyItemLabel__vIc9b {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 8px;
  padding-right: 17px;
}

.verifyItemValue__lM5bs {
  font-size: 12px;
  line-height: 20px;
  color: var(--inputs-disable-text);
  position: relative;
  min-height: 35px;
  max-height: 125px;
  padding: 7px 18px 8px 10px;
  border-radius: 0px 0px 2px 2px;
  background: var(--inputs-disable-disable-surface);
  border-radius: 5px;
}

.verifyItemValueHtml__ELF3O {
  overflow: auto;
}
.verifyItemValueHtml__ELF3O::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.verifyItemValueHtml__ELF3O::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.verifyItemValueHtml__ELF3O::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.verifyItemValueHtml__ELF3O::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.verifyItemValueHtml__ELF3O p {
  margin: 0;
}
.verifyItemValueHtml__ELF3O img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.fullHeight__wNSgh {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CompletionReportModal/components/VerifyValueItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;AADE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAGJ;AAAE;EACE,+BAAA;EACA,kBAAA;AAEJ;AACE;EACE,8BAAA;EACA,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,kBAAA;AAAJ;AA6DI;EACE,SAAA;AA3DN;AA8DI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA5DN;;AAiEA;EACE,YAAA;AA9DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.verifyItemLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 8px;\n  padding-right: 17px;\n}\n\n.verifyItemValue {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--inputs-disable-text);\n  position: relative;\n  min-height: 35px;\n  max-height: 125px;\n  padding: 7px 18px 8px 10px;\n  border-radius: 0px 0px 2px 2px;\n  background: var(--inputs-disable-disable-surface);\n  border-radius: 5px;\n}\n\n.verifyItemValueHtml {\n  overflow: auto;\n\n  @include scrollBar;\n\n  :global {\n    p {\n      margin: 0;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n}\n\n.fullHeight {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verifyItemLabel": `verifyItemLabel__vIc9b`,
	"verifyItemValue": `verifyItemValue__lM5bs`,
	"verifyItemValueHtml": `verifyItemValueHtml__ELF3O`,
	"fullHeight": `fullHeight__wNSgh`
};
module.exports = ___CSS_LOADER_EXPORT___;
